import {
	DialogContent,
	Dialog,
	DialogTitle,
	TextField,
	DialogActions,
	Button,
	Box,
	Select,
	MenuItem,
	InputLabel,
	FormControl,
} from '@mui/material';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { CountrySelectMenu } from 'ui/CountrySelectMenu';
import {
	ECountryType,
	ESortDirection,
	ETableStructureType,
} from '../../../../../../ui/EasTable/types';
import { ETypeOfDialog } from './constants';
import {
	createEmVatRequest,
	updateEmVatRequest,
} from '../../../../../../redux/reducers/emVat/reducer';
import { EVatType, TEmVatListItem } from '../../../../../../redux/reducers/emVat/types';

export const EditVatNumbersDialog = ({
	open,
	setClose,
	typeOfDialog = ETypeOfDialog.EDIT,
	data,
}: {
	open: boolean;
	setClose: () => void;
	typeOfDialog?: ETypeOfDialog;
	data: TEmVatListItem | null;
}) => {
	const dispatch = useDispatch();
	const { emId } = useParams();

	const [vatNumber, setVatNumber] = useState('');
	// const [vatType, setVatType] = useState<EVatType | null>(null);
	const [address, setAddress] = useState('');
	const [name, setName] = useState('');
	const [country, setCountry] = useState('');
	const [countryNumber, setCountryNumber] = useState(0);
	// const [countryList, setCountryList] = useState([]);

	const reset = () => {
		setVatNumber('');
		// setVatType(null);
		setAddress('');
		setName('');
		setCountry('');
		setCountryNumber(0);
	};

	const [prevData, setPrevData] = useState<TEmVatListItem | null>(data);
	const [prevOpen, setPrevOpen] = useState(open);

	if ((data !== prevData || open !== prevOpen) && typeOfDialog === ETypeOfDialog.EDIT) {
		setPrevData(data);
		setPrevOpen(open);
		if (open && data) {
			setVatNumber(data.vatNumber ?? '');
			// setVatType(data.vatType);
			setAddress(data.address ?? '');
			setName(data.name ?? '');
			setCountry(data.countryCode ?? '');
			setCountryNumber(data.countryId ?? 0);
		}
	}

	const handleSave = () => {
		if (!emId) return;
		// if (!vatType) return;

		if (typeOfDialog === ETypeOfDialog.EDIT) {
			dispatch(
				updateEmVatRequest({
					vatType: EVatType.FIXED_ESTABLISHMENT,
					id: data?.id ?? 0,
					body: {
						emId: Number(emId),
						vatNumber,
						address,
						name,
						countryId: Number(countryNumber),
					},
					listRequest: {
						pageNumber: 1,
						pageSize: 100,
						searchString: '',
						filters: [{ fieldName: 'emId', value: emId ?? 0, operator: '=' }],
						orderBy: [{ fieldName: 'id', direction: ESortDirection.DESC }],
					},
				}),
			);
		} else {
			dispatch(
				createEmVatRequest({
					vatType: EVatType.FIXED_ESTABLISHMENT,
					body: {
						vatNumber,
						address,
						name,
						countryId: Number(countryNumber),
						emId: Number(emId),
					},
					listRequest: {
						pageNumber: 1,
						pageSize: 100,
						searchString: '',
						filters: [{ fieldName: 'emId', value: emId ?? 0, operator: '=' }],
						orderBy: [{ fieldName: 'id', direction: ESortDirection.DESC }],
					},
				}),
			);
		}

		setClose();
		reset();
	};

	return (
		<Dialog open={open} onClose={setClose}>
			<DialogTitle>
				{typeOfDialog === ETypeOfDialog.ADD ? 'Add VAT Number' : 'Edit VAT Number'}
			</DialogTitle>
			<DialogContent>
				<Box
					sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '500px', marginTop: 2 }}
				>
					<TextField
						label="VAT Number"
						fullWidth
						value={vatNumber}
						onChange={(e) => setVatNumber(e.target.value)}
					/>
					{/* {typeOfDialog === ETypeOfDialog.ADD && (
						<FormControl fullWidth>
							<InputLabel id="vat-type-label">VAT Type</InputLabel>
							<Select
								labelId="vat-type-label"
								label="VAT Type"
								fullWidth
								value={vatType}
								onChange={(e) => setVatType(e.target.value as EVatType)}
							>
								<MenuItem value={EVatType.WAREHOUSE}>Warehouse</MenuItem>
								<MenuItem value={EVatType.FIXED_ESTABLISHMENT}>Fixed Establishment</MenuItem>
							</Select>
						</FormControl>
					)} */}
					{/* <Select
							label="VAT Type"
							fullWidth
							value={vatType}
							onChange={e => setVatType(e.target.value as EVatType)}
						>
							<MenuItem value={EVatType.WAREHOUSE}>Warehouse</MenuItem>
							<MenuItem value={EVatType.FIXED_ESTABLISHMENT}>Fixed Establishment</MenuItem>
						</Select>
					)} */}
					<TextField
						label="Address"
						fullWidth
						value={address}
						onChange={(e) => setAddress(e.target.value)}
					/>
					<TextField
						label="Name"
						fullWidth
						value={name}
						onChange={(e) => setName(e.target.value)}
					/>
					<CountrySelectMenu
						// countryList={countryList ?? []}
						// countryCode={country}
						countryNumber={countryNumber ?? 0}
						onChangeNumber={(c: number) => {
							// console.log('countryNumber', c);
							setCountryNumber(c);
						}}
						size="medium"
						type={ETableStructureType.COUNTRY_NUMBER}
						typeOfCountry={ECountryType.EU}
					/>
				</Box>
			</DialogContent>
			<DialogActions>
				<Button
					onClick={() => {
						setClose();
						reset();
					}}
				>
					Cancel
				</Button>
				<Button onClick={handleSave}>Save</Button>
			</DialogActions>
		</Dialog>
	);
};
